var map = {
	"./IoT互联.png": 5972,
	"./L-TMS.png": 9213,
	"./OA审批.png": 2654,
	"./专业方案.png": 9663,
	"./业务互联.png": 6903,
	"./发货管理.png": 1110,
	"./司机画像.png": 8043,
	"./客户在线.png": 2650,
	"./数智管理.png": 6156,
	"./智能账务 备用.png": 8875,
	"./智能账务.png": 8823,
	"./生产对接.png": 7045,
	"./社群管理.png": 4084,
	"./车务管理.png": 8695,
	"./运力协同.png": 7631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5500;